import { ROLES } from "../../constants";

// function to get filtered transactiions based on type tm cash or tm credit
const roleRedirect = (userDto) => {
  let role = userDto.role;
  let isPicker = null;
  let isToPicker = null;
  let isChecker = null;
  let isToChecker = null;
  let isPacker = null;
  let isDispatch = null;
  let currUrl = null;
  let isBinTransfer = null;
  let isPutAway = null;
  let isTOPacker = null;

  if (role.find((o) => o.roleName === ROLES.CHECKER_ROLE)) {
    isChecker = true;
  }

  if (role.find((o) => o.roleName === ROLES.TO_CHECKER_ROLE)) {
    isToChecker = true;
  }

  if (role.find((o) => o.roleName === ROLES.TO_PICKER_ROLE)) {
    isToPicker = true;
  }
  if (role.find((o) => o.roleName === ROLES.PICKER_ROLE)) {
    isPicker = true;
  }

  if (role.find((o) => o.roleName === ROLES.PACKER_ROLE)) {
    isPacker = true;
  }

  if (role.find((o) => o.roleName === ROLES.DISPATCH_ROLE)) {
    isDispatch = true;
  }

  if (role.find((o) => o.roleName === ROLES.BIN_TRANSFER)) {
    isBinTransfer = true;
  }

  if (role.find((o) => o.roleName === ROLES.PUT_AWAY_ROLE)) {
    isPutAway = true;
  }

  if (role.find((o) => o.roleName === ROLES.TO_PACKER_ROLE)) {
    isTOPacker = true;
  }

  if (isChecker && !isPicker && !isPacker && !isDispatch) {
    currUrl = "/markorder";
    document.title = "Truemeds - Checker";
  } else if (isToChecker && !isToPicker) {
    currUrl = "/checker-to";
    document.title = "Truemeds - TO Checker";
  } else if (!isToChecker && isToPicker) {
    currUrl = "/to-picker";
    document.title = "Truemeds - TO Picker";
  } else if (isPutAway) {
    currUrl = "/put-away-invoices";
    document.title = "Truemeds - Put Away Invoices";
  } else if (isTOPacker) {
    currUrl = "/to-container-packing";
    document.title = "Truemeds - TO Container Packing";
  } else if (isBinTransfer) {
    currUrl = "/to-bin-picker";
    document.title = "Truemeds - TO Bin Transfer";
  } else if (isToChecker && isToPicker) {
    currUrl = "/to-picker";
    document.title = "Truemeds - TO Picker";
  } else if (isPicker && !isChecker && !isPacker && !isDispatch) {
    currUrl = "/picker";
    document.title = "Truemeds - Picker";
  } else if (isPacker && !isChecker && !isPicker && !isDispatch) {
    currUrl = "/packer";
    document.title = "Truemeds - Packer";
  } else if (isDispatch && !isChecker && !isPicker && !isPacker) {
    currUrl = "/dispatch";
    document.title = "Truemeds - Dispatch";
  } else {
    currUrl = "/profile";
    document.title = "Truemeds - WarehouseAdmin";
  }

  return currUrl;
};

export default roleRedirect;
